var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","d":"M12.5 15.8335L6.66667 10.0002L12.5 4.16683","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Arrow.defaultProps = {"viewBox":"0 0 20 20","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
